import { render, staticRenderFns } from "./EditSerialNumber.vue?vue&type=template&id=0cd67016&scoped=true"
import script from "./EditSerialNumber.vue?vue&type=script&lang=js"
export * from "./EditSerialNumber.vue?vue&type=script&lang=js"
import style0 from "./EditSerialNumber.vue?vue&type=style&index=0&id=0cd67016&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd67016",
  null
  
)

export default component.exports